import * as React from 'react';
export const chevronLeftSvg = React.forwardRef(function chevronLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.619.381a.875.875 0 0 1 0 1.238L5.237 8l6.382 6.381a.875.875 0 1 1-1.238 1.238l-7-7a.875.875 0 0 1 0-1.238l7-7a.875.875 0 0 1 1.238 0Z',
    }),
  );
});
chevronLeftSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronLeft = {
  category: 'icon',
  colorable: true,
  name: 'chevronLeft',
  svg: chevronLeftSvg,
};
